import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../store/state";

interface Props {
  children: JSX.Element
}

export default function PrivateRoute({ children }: Props) {
  const user = useSelector((state: RootState) => state.auth.user);
  const location = useLocation();
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
}
